export const SAVE_BUTTON_ICON = 'icon-save';
